export default function ({ redirect, store }) {
  if (store.getters['auth/newArchiveEnabled']) {
    redirect('/2/documents')
  }
}
